import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import { actions as baselineTaskActions } from '../../../actions/baselineTaskActions';
import { actions as taskTagActions } from '../../../actions/taskTagActions';
import PropTypes from 'prop-types';
import DrawerV6 from '../../Common/Drawer/DrawerV6/DrawerV6';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Modal61 from '../../Common/Modal/Modal61';
import InputText from '../../Common/InputText';
import ColorChooser from '../../Common/ColorChooser';
import Tag from '../../Common/Tag/Tag';
import './BulkUpdateAttributesDrawer.scss';
// for popover
import $ from 'jquery';
import MultiSelectBoxV6 from '@Components/Common/MultiSelectBoxV6/MultiSelectBoxV6';
import ToggleV6 from '@Components/Common/ToggleV6/ToggleV6';
window.jQuery = $;
require('bootstrap');

export class BulkUpdateAttributesDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isFormValid: true,
			isLoading: false,

			isTrickleDown: true,

			departments: [],
			jobTitles: [],
			communities: [],
			phases: [],
			tags: [],

			departmentId: 0,
			jobTitleId: 0,
			communityId: 0,
			phaseId: 0,
			taskTagIds: [],
			newTaskTag: {
				name: '',
				bgColor: '#5F0DF0',
				fontColor: '#ffffff',
			},
			isNewTagFormValid: true,
			isAddNewTagModalLoading: false,
			isMilestone: null,
		};

		this.infoRef = React.createRef();
		this.tagModal = React.createRef();
	}

	componentDidMount = async () => {
		if (this.props.checkedTasks.length < 1) {
			Notification('error', 'Error', 'At least one location must be selected');
			this.onCancel();
		}
		await this.loadFilters();
		$(this.infoRef.current).popover();
	};

	componentDidUpdate(prevProps) {
		if (this.props.baselineId && this.props.baselineId !== prevProps.baselineId) {
			this.loadFilters();
		}
	}

	loadFilters = async () => {
		try {
			this.setState({ isLoading: true });
			let response = await this.props.baselineTaskActions.loadBulkUpdateAttributeFilters(this.props.baselineId);
			if (response.type === types.LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_SUCCESS) {
				const addNewTagOption = {
					id: -9999,
					name: '+ Add New Task Tag',
					styles: {
						backgroundColor: '#F7F5FF',
						color: '#46389E',
					},
				};

				this.setState({
					departments: response.payload.departments,
					communities: response.payload.communities,
					jobTitles: response.payload.baselineJobTitles,
					phases: response.payload.phases,
					tags: [...response.payload.tags, addNewTagOption],
				});
			} else if (response.type === types.LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	onSave = async () => {
		try {
			if (!this.state.departmentId && !this.state.communityId && !this.state.jobTitleId && !this.state.phaseId && !this.state.taskTagIds) {
				Notification('error', 'Error', 'You must change at least one attribute');
				return;
			}

			this.setState({ isLoading: true });

			let tags;

			if (this.state.taskTagIds && this.state.taskTagIds.length > 0) {
				tags = !Array.isArray(this.state.taskTagIds) ? this.state.taskTagIds.split(',') : this.state.taskTagIds.join().split(',');
			}

			const request = {
				departmentId: this.state.departmentId,
				jobTitleId: this.state.jobTitleId,
				communityId: this.state.communityId,
				phaseId: this.state.phaseId,
				trickleDown: this.state.isTrickleDown,
				baselineTaskIds: this.props.checkedTasks.map((m) => m.id),
				taskTagIds: tags,
				isMilestone: this.state.isMilestone,
			};

			const response = await this.props.baselineTaskActions.bulkUpdateAttributes(request);
			if (response.type === types.PERFORM_BULK_UPDATE_ATTRIB_SUCCESS) {
				Notification('success', 'Success', 'Attributes updated successfully');
				// make sure the info popover is closed first
				$(this.infoRef.current).popover('dispose');
				this.props.onComplete();
			} else if (response.type === types.PERFORM_BULK_UPDATE_ATTRIB_FAILURE) {
				Notification('error', 'Error', response.payload.message);
				this.setState({ isLoading: false });
			}
		} catch (error) {
			Notification('error', 'Error', error);
			this.setState({ isLoading: false });
		}
	};

	onMultiSelectChange = (value, name) => {
		if (name === 'taskTagIds' && value.includes('-9999')) {
			// User selected the add new option for task tags
			this.tagModal.current.show();
		} else {
			this.setState({ [name]: value });
		}
	};

	onToggleChange = (name, isChecked) => {
		this.setState({ isTrickleDown: isChecked });
	};

	onCancel = () => {
		// make sure the info popover is closed first
		$(this.infoRef.current).popover('dispose');
		this.props.onCancel();
	};

	onCreatenewTaskTag = async () => {
		if (!this.validateCreateNewTagForm()) return false;

		this.setState({ isAddNewTagModalLoading: true });

		const newTag = {
			id: 0,
			name: this.state.newTaskTag.name,
			fontColor: this.state.newTaskTag.fontColor,
			backgroundColor: this.state.newTaskTag.bgColor,
			isActive: true,
		};

		try {
			const result = await this.props.taskTagActions.saveTag(newTag);

			if (result.type === types.CREATE_TASK_TAG_SUCCESS || result.type === types.UPDATE_TASK_TAG_SUCCESS) {
				Notification('success', 'Save Successful', 'Task Tag created');
				this.setState({ isAddNewTagModalLoading: false });
				this.tagModal.current.hide();
				await this.loadFilters();
			} else if (result.type === types.CREATE_TASK_TAG_FAILURE || result.type === types.UPDATE_TASK_TAG_FAILURE) {
				Notification('error', 'An Error Occurred', result.payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		}
	};

	validateCreateNewTagForm = () => {
		if (this.state.newTaskTag.name.trim().length < 1) {
			this.setState({ isNewTagFormValid: false });
			return false;
		} else {
			return true;
		}
	};

	onNewTagFormChange = (name, value) => {
		this.setState({ newTaskTag: { ...this.state.newTaskTag, [name]: value } });
	};

	closeTagModal = async () => {
		this.tagModal.current.hide();
		this.setState({ isAddNewTagModalLoading: false });
	};

	render() {
		return (
			<DrawerV6 isWide={false} title='Update Attributes' onSaveClick={this.onSave} saveText={'Update'} onCancelClick={this.onCancel}>
				<LoadingIndicator isLoading={this.state.isLoading}>
					<form className='update-attr-drawer' noValidate>
						<div className='row'>
							<div className='col'>
								<MultiSelectBoxV6
									name='departmentId'
									label='Departments'
									idField='id'
									valueField='name'
									options={this.state.departments}
									selectedValues={this.state.departmentId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>
								<MultiSelectBoxV6
									name='jobTitleId'
									label='Job Titles'
									idField='id'
									valueField='name'
									options={this.state.jobTitles}
									selectedValues={this.state.jobTitleId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>
								<MultiSelectBoxV6
									name='communityId'
									label='Communities'
									idField='id'
									valueField='name'
									options={this.state.communities}
									selectedValues={this.state.communityId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>
								<MultiSelectBoxV6
									name='phaseId'
									label='Phases'
									idField='id'
									valueField='name'
									options={this.state.phases}
									selectedValues={this.state.phaseId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>
								<MultiSelectBoxV6
									name='taskTagIds'
									options={this.state.tags}
									idField='id'
									valueField='name'
									selectedValues={this.state.taskTagIds.toString()}
									onChange={this.onMultiSelectChange}
									isMulti={true}
									label='Additional Task Tags'
								/>
								<MultiSelectBoxV6
									name='isMilestone'
									label='Milestone'
									options={[
										{ id: 'true', name: 'Update selected to be a Milestone' },
										{ id: 'false', name: 'Update selected to Not be a Milestone' },
									]}
									idField='id'
									valueField='name'
									selectedValues={this.state.isMilestone ? this.state.isMilestone : ''}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>
								<div className='row'>
									<ToggleV6
										name='isTrickleDown'
										text='Update location tasks with new selection'
										checked={this.state.isTrickleDown}
										onChange={this.onToggleChange}
									/>
								</div>
							</div>
						</div>
						<Modal61
							title='Create New Task Tag'
							ref={this.tagModal}
							body={
								<form name='newProjectManagerForm' noValidate className={this.state.isNewTagFormValid ? '' : 'was-validated'}>
									<div className='form-group'>
										<label htmlFor='project-tag-name' className='title'>
											Task Tag Name
										</label>
										<InputText
											name='project-tag-name'
											type='text'
											value={this.state.newTaskTag.name}
											onChange={(e) => this.onNewTagFormChange('name', e.target.value)}
											isRequired={true}
											errorMessage='Task Tag Name is required'
											maxLength={50}
										/>
										<small id='project-tag-name-help' className='form-text text-muted sub-title'>
											Character Limit 50
										</small>
									</div>
									<ColorChooser
										name='backgroundColor'
										title='Background Color'
										selectedColor={this.state.newTaskTag.bgColor}
										onChange={(color) => this.onNewTagFormChange('bgColor', color)}
									/>
									<ColorChooser
										name='fontColor'
										title='Font Color'
										selectedColor={this.state.newTaskTag.fontColor}
										onChange={(color) => this.onNewTagFormChange('fontColor', color)}
									/>
									<div className='mt-5'>
										<span className='me-2'>Preview:</span>
										<Tag
											title={this.state.newTaskTag.name}
											backgroundColor={this.state.newTaskTag.bgColor}
											color={this.state.newTaskTag.fontColor}
										/>
									</div>
								</form>
							}
							primaryButtonText='Save'
							onPrimaryClick={() => this.onCreatenewTaskTag()}
							showSecondaryButton={true}
							onSecondaryClick={this.closeTagModal}
							onCloseClick={this.closeTagModal}
							isLoading={this.state.isAddNewTagModalLoading}
						/>
					</form>
				</LoadingIndicator>
			</DrawerV6>
		);
	}
}

BulkUpdateAttributesDrawer.propTypes = {
	baselineId: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	checkedTasks: PropTypes.array.isRequired,
	baselineTaskActions: PropTypes.object.isRequired,
	taskTagActions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		baselineTaskActions: bindActionCreators(baselineTaskActions, dispatch),
		taskTagActions: bindActionCreators(taskTagActions, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(BulkUpdateAttributesDrawer);
